import styled from 'styled-components';

const ThreadItemTitle = styled.h3`
  margin: 4px 0;
`;

export default ThreadItemTitle;
